// This file is generated during build process by: ./node-bin/gen-lab-version
export default {
  "repo": {
    "branch": "production",
    "commit": {
      "sha": "79ef76bbc0f8cae65b8593a7ada969878c580305",
      "short_sha": "79ef76b",
      "url": "https://github.com/concord-consortium/lab/commit/79ef76b",
      "author": "Ethan McElroy",
      "email": "emcelroy@concord.org",
      "date": "2023-06-07 17:45:28 -0400",
      "message": "Merge pull request #159 from concord-consortium/184463878-update-to-google-analytics-4chore: Update to Google Analytics 4 (PT-184463878)"
    },
    "last_tag": "v1.17.5",
    "dirty": false
  }
};